import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ListService } from '@fry/lib/list';

@Component({
    selector: 'app-user-fields',
    templateUrl: './user-fields.component.html',
    providers: [
        ListService
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class UserFieldsComponent { }
